export var FUT_TOP_GAINERS_LOSERS = "FUT_TOP_GAINERS_LOSERS";
export var FUT_TOP_GAINERS_LOSERS_STREAM = "FUT_TOP_GAINERS_LOSERS_STREAM";
export var FUT_TOP_GAINERS_LOSER_LAST_TIME_UPDATED = "FUT_TOP_GAINERS_LOSER_LAST_TIME_UPDATED";
